import { LoadingButton } from "@mui/lab";
import { Alert, Button, CircularProgress, Dialog, DialogContent, DialogTitle } from "@mui/material"
import { ErrorMessage, Formik } from "formik";
import * as Yup from 'yup';
import { fileUploadRequest, postRequest, putRequest } from "utils/apiRequest";
import React from "react";


const CSVSchema = Yup.object().shape({
    file: Yup.string().required('File is required'),
    type: Yup.mixed().oneOf(['products', 'tracking', 'orders', 'warehouses']).required('Type is required'),
})

const CsvDialogContent = (props) => {
    const { type } = props;
    const [success, setSuccess] = React.useState(false);
    const [signedUrl, setSignedUrl] = React.useState(null);
    React.useEffect(()=>{
        let fd = new FormData();
        fd.append('type', type);
        postRequest('/file/presignedUrl', fd).then(data => {
            setSignedUrl(data.url);
        });
    }, []);
    return (<>{signedUrl === null ? <CircularProgress /> : (<>
    <Formik
        initialValues={{
            file: null,
            type: type
        }}
        validationSchema={CSVSchema}
        enableReinitialize={true}
        onSubmit={(values, { setErrors, setStatus, setSubmitting }) => {
            setSuccess(false);
            setSubmitting(true);
            fileUploadRequest(signedUrl, values.file, { 'Content-Type': 'text/csv', 'x-amz-acl': 'public-read' }).then(d => {
                if (d.errors) {
                    const err = {}
                    Object.keys(d.errors).forEach((k) => {
                        err[k] = d.errors[k][0];
                    })
                    setErrors(err);
                } else {
                    setSuccess(true);
                }
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                setSubmitting(false);
            })
        }}>
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
            <form noValidate onSubmit={handleSubmit}>
                {success ? (
                    <Alert severity="success">File Uploaded</Alert>
                ) : (<>
                <input type="hidden" id="type" name="type" value={values.type} />
                <div>
                    <input type="file" id="file" name="file" onChange={(event) => {
                        const file = event.target.files[0];
                        setFieldValue("file", file);
                    }} />
                    <LoadingButton
                        disableElevation
                        disabled={isSubmitting}
                        size="large"
                        type="submit"
                        variant="contained"
                        color="primary"
                        loading={isSubmitting}
                        onClick={handleSubmit}
                    >
                        Upload
                    </LoadingButton>
                </div>
                <ErrorMessage name="csv" />
                <ErrorMessage name="type" />
                </>
                )}
            </form>
        )}
    </Formik>
    </>)}
    </>)
}

export default function CsvUploader(props) {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const uploadCsv = () => {
        setDialogOpen(true);
    }
    return (<>
        <Button onClick={() => uploadCsv()} variant="outlined">Upload CSV</Button>
        <Dialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
        >
            <DialogTitle>CSV {props.type} upload</DialogTitle>
            <DialogContent>
                <CsvDialogContent type={props.type} />
            </DialogContent>
        </Dialog>
        </>
    )
}